import apiClient from './ApiClient';
import {AuthRepository} from './AuthRepository';
import {DateSlotRepository} from './DateSlotRepository';
import {TimeSlotRepository} from './TimeSlotRepository';
import {CategoryRepository} from './CategoryRepository';
import {ServiceRepository} from './ServiceRepository';
import {BookingRepository} from './BookingRepository';
import {OrderRepository} from './OrderRepository';
import {CompanyRepository} from './CompanyRepository';
import {StockRepository} from './StockRepository';
import {FileRepository} from './FileRepository';
import {SubscriptionRepository} from './SubscriptionRepository';
import {BookingRequestRepository} from './BookingRequestRepository';
import {StaffRepository} from './StaffRepository';
import {WorkflowRepository} from './WorkflowRepository';
import {WorkflowInstanceRepository} from './WorkflowInstanceRepository';
import {PaymentRepository} from './PaymentRepository';
import {PushRepository} from './PushRepository';
import {ChatRepository} from './ChatRepository';


export class RepositoryContainer {
	constructor(client = apiClient) {
		this.apiClient = client;
		
		// Initialize all repositories
		this.auth = new AuthRepository(this.apiClient);
		this.dateSlot = new DateSlotRepository(this.apiClient);
		this.timeSlot = new TimeSlotRepository(this.apiClient);
		this.category = new CategoryRepository(this.apiClient);
		this.service = new ServiceRepository(this.apiClient);
		this.booking = new BookingRepository(this.apiClient);
		this.order = new OrderRepository(this.apiClient);
		this.company = new CompanyRepository(this.apiClient);
		this.stock = new StockRepository(this.apiClient);
		this.file = new FileRepository(this.apiClient);
		this.subscription = new SubscriptionRepository(this.apiClient);
		this.bookingRequest = new BookingRequestRepository(this.apiClient);
		this.staff = new StaffRepository(this.apiClient);
		this.workflow = new WorkflowRepository(this.apiClient);
		this.workflowInstance = new WorkflowInstanceRepository(this.apiClient);
		this.payment = new PaymentRepository(this.apiClient);
		this.push = new PushRepository(this.apiClient);
		this.chat = new ChatRepository(this.apiClient);
	}

	get(name) {
		return this[name];
	}

	register(name, repoInstance) {
		this[name] = repoInstance;
		return this;
	}

	setToken(token) {
		if (this.apiClient && typeof this.apiClient.setToken === 'function') {
			this.apiClient.setToken(token);
		}
		return this;
	}

	overrideClient(client) {
		this.apiClient = client;
		
		// Update all repositories to use new client
		if (this.auth && typeof this.auth === 'object') this.auth.client = client;
		if (this.dateSlot && typeof this.dateSlot === 'object') this.dateSlot.client = client;
		if (this.timeSlot && typeof this.timeSlot === 'object') this.timeSlot.client = client;
		if (this.category && typeof this.category === 'object') this.category.client = client;
		if (this.service && typeof this.service === 'object') this.service.client = client;
		if (this.booking && typeof this.booking === 'object') this.booking.client = client;
		if (this.order && typeof this.order === 'object') this.order.client = client;
		if (this.company && typeof this.company === 'object') this.company.client = client;
		if (this.stock && typeof this.stock === 'object') this.stock.client = client;
		if (this.file && typeof this.file === 'object') this.file.client = client;
		if (this.subscription && typeof this.subscription === 'object') this.subscription.client = client;
		if (this.bookingRequest && typeof this.bookingRequest === 'object') this.bookingRequest.client = client;
		if (this.staff && typeof this.staff === 'object') this.staff.client = client;
		if (this.workflow && typeof this.workflow === 'object') this.workflow.client = client;
		if (this.workflowInstance && typeof this.workflowInstance === 'object') this.workflowInstance.client = client;
		if (this.payment && typeof this.payment === 'object') this.payment.client = client;
		if (this.push && typeof this.push === 'object') this.push.client = client;
		if (this.chat && typeof this.chat === 'object') this.chat.client = client;
		return this;
	}
}

export default new RepositoryContainer(apiClient);
